import { Check, ShieldCheck } from "lucide-react";
import { FadeUp } from "./FadeUp";
import { PlanComparisonTable } from "./PlanComparisonTable";
import { FREE_URL, PRO_URL, COACHING_URL } from "../../lib/checkoutLinks";

const PLANS = [
  {
    id: "free",
    name: "Free",
    price: "₹0",
    period: "",
    features: ["AI diet plan", "Meal & water tracker", "View workout plan", "Community Feed", "3 meal swaps/week"],
    highlighted: false,
    order: "order-2 md:order-1",
    url: FREE_URL,
  },
  {
    id: "pro",
    name: "Pro",
    price: "₹249",
    strike: "₹499",
    period: "first month",
    note: "then ₹499/month",
    tag: "Most Popular",
    features: [
      "Everything in Free",
      "Gym Workout Logger",
      "AI Physique Check-ins",
      "Progress Reports + PDF",
      "Full progress charts",
      "Recipes & grocery list",
      "Unlimited meal swaps",
    ],
    highlighted: true,
    order: "order-1 md:order-2",
    url: PRO_URL,
  },
  {
    id: "coaching",
    name: "Coaching",
    price: "₹2,999",
    period: "/month",
    features: ["Everything in Pro", "Chat with Coach Arjun", "2 one-on-one calls/month", "Plan personally updated by coach"],
    highlighted: false,
    order: "order-3 md:order-3",
    url: COACHING_URL,
  },
];

export const Pricing = () => (
  <section id="pricing" className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10 md:mb-14">
          CHOOSE YOUR PLAN
        </h2>
      </FadeUp>
      <div className="flex flex-col md:grid md:grid-cols-3 gap-6 items-stretch mb-10">
        {PLANS.map((p, i) => (
          <FadeUp key={p.id} delay={i * 0.1} className={p.order}>
            <div
              data-testid={`pricing-card-${p.id}`}
              className={`relative h-full rounded-[24px] p-8 flex flex-col ${
                p.highlighted
                  ? "bg-[#141416] border-2 border-[#C6FF3D] shadow-[0_0_40px_rgba(198,255,61,0.15)]"
                  : "bg-[#141416] border border-[#232326]"
              }`}
            >
              {p.tag && (
                <span className="absolute -top-3 right-8 bg-[#C6FF3D] text-black text-xs font-semibold px-3 py-1 rounded-full">
                  {p.tag}
                </span>
              )}
              <h3 className="text-white text-xl font-semibold mb-1">{p.name}</h3>
              <p className="mb-1">
                {p.strike && <span className="text-[#A1A1AA] text-base line-through mr-2">{p.strike}</span>}
                <span className="font-display text-4xl text-white">{p.price}</span>
                <span className="text-[#A1A1AA] text-sm"> {p.period}</span>
              </p>
              {p.note && <p className="text-[#A1A1AA] text-xs mb-5">{p.note}</p>}
              {!p.note && <div className="mb-5" />}
              <div className="space-y-3 mb-8 flex-1">
                {p.features.map((f) => (
                  <div key={f} className="flex items-start gap-2 text-sm text-[#A1A1AA]">
                    <Check size={16} className="text-[#C6FF3D] mt-0.5 flex-shrink-0" />
                    {f}
                  </div>
                ))}
              </div>
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`pricing-cta-${p.id}`}
                className={`tap-target flex items-center justify-center text-center font-semibold px-6 py-3 rounded-full transition-all duration-300 ${
                  p.highlighted
                    ? "bg-[#C6FF3D] text-black hover:scale-105"
                    : "border border-[#232326] text-white hover:border-[#C6FF3D] hover:text-[#C6FF3D]"
                }`}
              >
                Get Started
              </a>
            </div>
          </FadeUp>
        ))}
      </div>

      <FadeUp>
        <h3 className="text-white text-xl font-semibold text-center mb-6">Compare Plans</h3>
      </FadeUp>
      <PlanComparisonTable />

      <FadeUp>
        <div className="flex justify-center mt-10">
          <div
            data-testid="money-back-guarantee"
            className="flex items-center gap-3 bg-[#141416] border border-[#232326] rounded-full px-6 py-3"
          >
            <ShieldCheck className="text-[#C6FF3D]" size={20} />
            <span className="text-white text-sm font-semibold">7-Day Money-Back Guarantee</span>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
